import { queryOptions } from "@tanstack/react-query";
import { getOccTransport } from "~/common/api/occTransport";

export interface FormOption {
  code: string;
  name: string;
}

export interface CountryFormOption {
  isoCode: string;
  name: string;
}

export interface FormOptions {
  titleOptions: FormOption[];
  salutationOptions: FormOption[];
  countryOptions: CountryFormOption[];
}

function requestContext() {
  return {
    siteUid: window.__SCHA_BOOT__?.siteUid ?? "",
    language: window.__SCHA_BOOT__?.language ?? "",
  };
}

export async function fetchFormOptions(): Promise<FormOptions> {
  const { language } = requestContext();
  const transport = getOccTransport();
  const query = new URLSearchParams();
  if (language) {
    query.set("lang", language);
  }
  const suffix = query.size > 0 ? `?${query.toString()}` : "";
  const response = await transport.request(
    transport.url(`/reference-data/form-options${suffix}`),
    { headers: { Accept: "application/json" } },
    { accountContext: "omit" },
  );

  if (!response.ok) {
    throw new Error(`Failed to load form options: ${response.status}`);
  }
  return response.json() as Promise<FormOptions>;
}

export const formOptionsQueryOptions = () => {
  const { siteUid, language } = requestContext();
  return queryOptions({
    queryKey: ["reference-data", "form-options", siteUid, language],
    queryFn: fetchFormOptions,
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnWindowFocus: false,
    retry: 1,
  });
};
